/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseCalendarEntry } from '../models/BaseCalendarEntry';
import type { BaseCoachSP } from '../models/BaseCoachSP';
import type { CalendarEntryEdit } from '../models/CalendarEntryEdit';
import type { CalendarEntryIn } from '../models/CalendarEntryIn';
import type { CalendarEntryWithDistance } from '../models/CalendarEntryWithDistance';
import type { CoachMapViewFilters } from '../models/CoachMapViewFilters';
import type { CoachWithLocationAndShiftsAvailabilityType } from '../models/CoachWithLocationAndShiftsAvailabilityType';
import type { GenericStatus } from '../models/GenericStatus';
import type { LatLongWithName } from '../models/LatLongWithName';
import type { SearchCalendarEntry } from '../models/SearchCalendarEntry';
import type { SimpleCalendarEntry } from '../models/SimpleCalendarEntry';
import type { SimpleShiftWithJobAndCountListSchemaOut } from '../models/SimpleShiftWithJobAndCountListSchemaOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SPCoachesService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Add Calendar Entry To Coach
   * @param coachId
   * @param userLocationId
   * @param requestBody
   * @param force
   * @returns SimpleCalendarEntry Successful Response
   * @throws ApiError
   */
  public postSPCoachesAddCalendarEntryToCoach(
    coachId: number,
    userLocationId: number,
    requestBody: CalendarEntryIn,
    force: boolean = false
  ): CancelablePromise<SimpleCalendarEntry> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/sp/coaches/coach/{coach_id}/add_calendar_entry/location/{user_location_id}',
      path: {
        coach_id: coachId,
        user_location_id: userLocationId,
      },
      query: {
        force: force,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        400: `Bad Request`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * View Calendar Entry Conflicts When Adding
   * @param coachId
   * @param requestBody
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public postSPCoachesViewCalendarEntryConflictsWhenAdding(
    coachId: number,
    requestBody: CalendarEntryIn
  ): CancelablePromise<Array<BaseCalendarEntry>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/sp/coaches/coach/{coach_id}/add_calendar_entry/view/conflicts',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Calendar Entries From Coach
   * @param coachId
   * @param startDate
   * @param endDate
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public getSPCoachesGetCalendarEntriesFromCoach(
    coachId: number,
    startDate: string = '2025-03-06',
    endDate: string = '2025-03-20'
  ): CancelablePromise<Array<BaseCalendarEntry>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/sp/coaches/coach/{coach_id}/calendar_entries',
      path: {
        coach_id: coachId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Search Calendar Entries
   * @param requestBody
   * @param coachId
   * @param offset
   * @param limit
   * @returns CalendarEntryWithDistance Successful Response
   * @throws ApiError
   */
  public postSPCoachesSearchCalendarEntries(
    requestBody: SearchCalendarEntry,
    coachId?: number | null,
    offset?: number,
    limit: number = 100
  ): CancelablePromise<Array<CalendarEntryWithDistance>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/sp/coaches/coach/calendar_entries/search',
      query: {
        coach_id: coachId,
        offset: offset,
        limit: limit,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Change Calendar Entry Location
   * @param calendarEntryId
   * @param userLocationId
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public patchSPCoachesChangeCalendarEntryLocation(
    calendarEntryId: number,
    userLocationId: number
  ): CancelablePromise<BaseCalendarEntry> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/sp/coaches/coach/calendar_entry/{calendar_entry_id}/change_location/{user_location_id}',
      path: {
        calendar_entry_id: calendarEntryId,
        user_location_id: userLocationId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Change Calendar Entry
   * @param calendarEntryId
   * @param requestBody
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public patchSPCoachesChangeCalendarEntry(
    calendarEntryId: number,
    requestBody: CalendarEntryEdit
  ): CancelablePromise<BaseCalendarEntry> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/sp/coaches/coach/calendar_entry/{calendar_entry_id}/edit',
      path: {
        calendar_entry_id: calendarEntryId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Calendar Entry
   * @param calendarEntryId
   * @returns GenericStatus Successful Response
   * @throws ApiError
   */
  public deleteSPCoachesDeleteCalendarEntry(
    calendarEntryId: number
  ): CancelablePromise<GenericStatus> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/sp/coaches/coach/calendar_entry/{calendar_entry_id}/delete',
      path: {
        calendar_entry_id: calendarEntryId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Competence To Coach
   * @param competenceId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public postSPCoachesAddCompetenceToCoach(
    competenceId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/sp/coaches/coach/{coach_id}/competence/{competence_id}',
      path: {
        competence_id: competenceId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Competence From Coach
   * @param competenceId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public deleteSPCoachesRemoveCompetenceFromCoach(
    competenceId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/sp/coaches/coach/{coach_id}/competence/{competence_id}',
      path: {
        competence_id: competenceId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Favourite Branch To Coach
   * Add a favourite branch to a coach.
   *
   * Args:
   * branch (Branch): The branch to be added as a favourite.
   * coach (Coach): The coach to add the favourite branch to.
   * db (Session): The database session.
   *
   * Returns:
   * BaseCoachSP: The updated coach object with the added favourite branch.
   * @param branchId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public postSPCoachesAddFavouriteBranchToCoach(
    branchId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/sp/coaches/coach/{coach_id}/branches/{branch_id}',
      path: {
        branch_id: branchId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Favourite Branch From Coach
   * Removes a favourite branch from a coach.
   *
   * Args:
   * branch (Branch): The branch to be removed from the coach's favourite branches.
   * coach (Coach): The coach from which the branch will be removed.
   * db (Session): The database session.
   *
   * Returns:
   * BaseCoachSP: The updated coach object.
   * @param branchId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public deleteSPCoachesRemoveFavouriteBranchFromCoach(
    branchId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/sp/coaches/coach/{coach_id}/branches/{branch_id}',
      path: {
        branch_id: branchId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Competence To Coach Bulk
   * @param coachId
   * @param requestBody
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public patchSPCoachesAddCompetenceToCoachBulk(
    coachId: number,
    requestBody: Array<number>
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/sp/coaches/coach/{coach_id}/competence/bulk',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Competence From Coach Bulk
   * @param coachId
   * @param requestBody
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public deleteSPCoachesRemoveCompetenceFromCoachBulk(
    coachId: number,
    requestBody: Array<number>
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/sp/coaches/coach/{coach_id}/competence/bulk',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Sp
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public getSPCoachesGetCoachSp(coachId: number): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/sp/coaches/coach/{coach_id}/sp_coach',
      path: {
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Shifts By Coach
   * ### Get all shifts worked by a coach within a certain time frame.
   *
   * Args:
   * -   `coach` (Coach): The coach for which to get the shifts.
   * -   `start_date` (date): The start date of the time frame.
   * -   `end_date` (date): The end date of the time frame.
   * -   `offset` (Optional[int], optional): The offset for pagination. Defaults to 0.
   * -   `limit` (Optional[int], optional): The limit for pagination. Defaults to 30.
   *
   * Returns:
   * -   SimpleShiftWithJobAndCountListSchemaOut: A list of shifts worked by the coach within the time frame.
   * - data: the shifts worked by the coach within the time frame.
   * - total_items: the total number of shifts worked by the coach within the time frame. (for pagination)
   * - total_pages: the total number of pages of shifts worked by the coach within the time frame. (for pagination)
   * @param coachId
   * @param startDate
   * @param endDate
   * @param offset
   * @param limit
   * @returns SimpleShiftWithJobAndCountListSchemaOut Successful Response
   * @throws ApiError
   */
  public getSPCoachesGetShiftsByCoach(
    coachId: number,
    startDate: string = '2025-02-11',
    endDate: string = '2025-04-12',
    offset?: number | null,
    limit?: number | null
  ): CancelablePromise<SimpleShiftWithJobAndCountListSchemaOut> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/sp/coaches/coach/{coach_id}/worked_shifts',
      path: {
        coach_id: coachId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        offset: offset,
        limit: limit,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Reserved Shifts By Coach
   * ### Get all shifts reserved by a coach within a certain time frame.
   *
   * Args:
   * -   `coach` (Coach): The coach for which to get the shifts.
   * -   `start_date` (date): The start date of the time frame.
   * -   `end_date` (date): The end date of the time frame.
   * -   `offset` (Optional[int], optional): The offset for pagination. Defaults to 0.
   * -   `limit` (Optional[int], optional): The limit for pagination. Defaults to 30.
   *
   * Returns:
   * -   SimpleShiftWithJobAndCountListSchemaOut: A list of shifts reserved by the coach within the time frame.
   * - data: the shifts reserved by the coach within the time frame.
   * - total_items: the total number of shifts reserved by the coach within the time frame. (for pagination)
   * - total_pages: the total number of pages of shifts reserved by the coach within the time frame. (for pagination)
   * @param coachId
   * @param startDate
   * @param endDate
   * @param offset
   * @param limit
   * @returns SimpleShiftWithJobAndCountListSchemaOut Successful Response
   * @throws ApiError
   */
  public getSPCoachesGetReservedShiftsByCoach(
    coachId: number,
    startDate: string = '2025-02-11',
    endDate: string = '2025-04-12',
    offset?: number | null,
    limit?: number | null
  ): CancelablePromise<SimpleShiftWithJobAndCountListSchemaOut> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/sp/coaches/coach/{coach_id}/reserved_shifts',
      path: {
        coach_id: coachId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        offset: offset,
        limit: limit,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Location Of Search Query In Map View
   * @param query
   * @returns LatLongWithName Successful Response
   * @throws ApiError
   */
  public postSPCoachesGetLocationOfSearchQueryInMapView(
    query: string
  ): CancelablePromise<LatLongWithName> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/sp/coaches/map_view/location_query',
      query: {
        query: query,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coaches In Map View
   * @param requestBody
   * @returns CoachWithLocationAndShiftsAvailabilityType Successful Response
   * @throws ApiError
   */
  public postSPCoachesGetCoachesInMapView(
    requestBody: CoachMapViewFilters
  ): CancelablePromise<Array<CoachWithLocationAndShiftsAvailabilityType>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/sp/coaches/map_view',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Calendar Entry To Coach
   * @param coachId
   * @param userLocationId
   * @param requestBody
   * @param force
   * @returns SimpleCalendarEntry Successful Response
   * @throws ApiError
   */
  public postSpAddCalendarEntryToCoachVLatest(
    coachId: number,
    userLocationId: number,
    requestBody: CalendarEntryIn,
    force: boolean = false
  ): CancelablePromise<SimpleCalendarEntry> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/sp/coaches/coach/{coach_id}/add_calendar_entry/location/{user_location_id}',
      path: {
        coach_id: coachId,
        user_location_id: userLocationId,
      },
      query: {
        force: force,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        400: `Bad Request`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * View Calendar Entry Conflicts When Adding
   * @param coachId
   * @param requestBody
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public postSpViewCalendarEntryConflictsWhenAddingVLatest(
    coachId: number,
    requestBody: CalendarEntryIn
  ): CancelablePromise<Array<BaseCalendarEntry>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/sp/coaches/coach/{coach_id}/add_calendar_entry/view/conflicts',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Calendar Entries From Coach
   * @param coachId
   * @param startDate
   * @param endDate
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public getSpGetCalendarEntriesFromCoachVLatest(
    coachId: number,
    startDate: string = '2025-03-06',
    endDate: string = '2025-03-20'
  ): CancelablePromise<Array<BaseCalendarEntry>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/sp/coaches/coach/{coach_id}/calendar_entries',
      path: {
        coach_id: coachId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Search Calendar Entries
   * @param requestBody
   * @param coachId
   * @param offset
   * @param limit
   * @returns CalendarEntryWithDistance Successful Response
   * @throws ApiError
   */
  public postSpSearchCalendarEntriesVLatest(
    requestBody: SearchCalendarEntry,
    coachId?: number | null,
    offset?: number,
    limit: number = 100
  ): CancelablePromise<Array<CalendarEntryWithDistance>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/sp/coaches/coach/calendar_entries/search',
      query: {
        coach_id: coachId,
        offset: offset,
        limit: limit,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Change Calendar Entry Location
   * @param calendarEntryId
   * @param userLocationId
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public patchSpChangeCalendarEntryLocationVLatest(
    calendarEntryId: number,
    userLocationId: number
  ): CancelablePromise<BaseCalendarEntry> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/sp/coaches/coach/calendar_entry/{calendar_entry_id}/change_location/{user_location_id}',
      path: {
        calendar_entry_id: calendarEntryId,
        user_location_id: userLocationId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Change Calendar Entry
   * @param calendarEntryId
   * @param requestBody
   * @returns BaseCalendarEntry Successful Response
   * @throws ApiError
   */
  public patchSpChangeCalendarEntryVLatest(
    calendarEntryId: number,
    requestBody: CalendarEntryEdit
  ): CancelablePromise<BaseCalendarEntry> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/sp/coaches/coach/calendar_entry/{calendar_entry_id}/edit',
      path: {
        calendar_entry_id: calendarEntryId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Calendar Entry
   * @param calendarEntryId
   * @returns GenericStatus Successful Response
   * @throws ApiError
   */
  public deleteSpDeleteCalendarEntryVLatest(
    calendarEntryId: number
  ): CancelablePromise<GenericStatus> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/latest/sp/coaches/coach/calendar_entry/{calendar_entry_id}/delete',
      path: {
        calendar_entry_id: calendarEntryId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Competence To Coach
   * @param competenceId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public postSpAddCompetenceToCoachVLatest(
    competenceId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/sp/coaches/coach/{coach_id}/competence/{competence_id}',
      path: {
        competence_id: competenceId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Competence From Coach
   * @param competenceId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public deleteSpRemoveCompetenceFromCoachVLatest(
    competenceId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/latest/sp/coaches/coach/{coach_id}/competence/{competence_id}',
      path: {
        competence_id: competenceId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Favourite Branch To Coach
   * Add a favourite branch to a coach.
   *
   * Args:
   * branch (Branch): The branch to be added as a favourite.
   * coach (Coach): The coach to add the favourite branch to.
   * db (Session): The database session.
   *
   * Returns:
   * BaseCoachSP: The updated coach object with the added favourite branch.
   * @param branchId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public postSpAddFavouriteBranchToCoachVLatest(
    branchId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/sp/coaches/coach/{coach_id}/branches/{branch_id}',
      path: {
        branch_id: branchId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Favourite Branch From Coach
   * Removes a favourite branch from a coach.
   *
   * Args:
   * branch (Branch): The branch to be removed from the coach's favourite branches.
   * coach (Coach): The coach from which the branch will be removed.
   * db (Session): The database session.
   *
   * Returns:
   * BaseCoachSP: The updated coach object.
   * @param branchId
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public deleteSpRemoveFavouriteBranchFromCoachVLatest(
    branchId: number,
    coachId: number
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/latest/sp/coaches/coach/{coach_id}/branches/{branch_id}',
      path: {
        branch_id: branchId,
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Competence To Coach Bulk
   * @param coachId
   * @param requestBody
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public patchSpAddCompetenceToCoachBulkVLatest(
    coachId: number,
    requestBody: Array<number>
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/sp/coaches/coach/{coach_id}/competence/bulk',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Competence From Coach Bulk
   * @param coachId
   * @param requestBody
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public deleteSpRemoveCompetenceFromCoachBulkVLatest(
    coachId: number,
    requestBody: Array<number>
  ): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/latest/sp/coaches/coach/{coach_id}/competence/bulk',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Sp
   * @param coachId
   * @returns BaseCoachSP Successful Response
   * @throws ApiError
   */
  public getSpGetCoachSpVLatest(coachId: number): CancelablePromise<BaseCoachSP> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/sp/coaches/coach/{coach_id}/sp_coach',
      path: {
        coach_id: coachId,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Shifts By Coach
   * ### Get all shifts worked by a coach within a certain time frame.
   *
   * Args:
   * -   `coach` (Coach): The coach for which to get the shifts.
   * -   `start_date` (date): The start date of the time frame.
   * -   `end_date` (date): The end date of the time frame.
   * -   `offset` (Optional[int], optional): The offset for pagination. Defaults to 0.
   * -   `limit` (Optional[int], optional): The limit for pagination. Defaults to 30.
   *
   * Returns:
   * -   SimpleShiftWithJobAndCountListSchemaOut: A list of shifts worked by the coach within the time frame.
   * - data: the shifts worked by the coach within the time frame.
   * - total_items: the total number of shifts worked by the coach within the time frame. (for pagination)
   * - total_pages: the total number of pages of shifts worked by the coach within the time frame. (for pagination)
   * @param coachId
   * @param startDate
   * @param endDate
   * @param offset
   * @param limit
   * @returns SimpleShiftWithJobAndCountListSchemaOut Successful Response
   * @throws ApiError
   */
  public getSpGetShiftsByCoachVLatest(
    coachId: number,
    startDate: string = '2025-02-11',
    endDate: string = '2025-04-12',
    offset?: number | null,
    limit?: number | null
  ): CancelablePromise<SimpleShiftWithJobAndCountListSchemaOut> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/sp/coaches/coach/{coach_id}/worked_shifts',
      path: {
        coach_id: coachId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        offset: offset,
        limit: limit,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Reserved Shifts By Coach
   * ### Get all shifts reserved by a coach within a certain time frame.
   *
   * Args:
   * -   `coach` (Coach): The coach for which to get the shifts.
   * -   `start_date` (date): The start date of the time frame.
   * -   `end_date` (date): The end date of the time frame.
   * -   `offset` (Optional[int], optional): The offset for pagination. Defaults to 0.
   * -   `limit` (Optional[int], optional): The limit for pagination. Defaults to 30.
   *
   * Returns:
   * -   SimpleShiftWithJobAndCountListSchemaOut: A list of shifts reserved by the coach within the time frame.
   * - data: the shifts reserved by the coach within the time frame.
   * - total_items: the total number of shifts reserved by the coach within the time frame. (for pagination)
   * - total_pages: the total number of pages of shifts reserved by the coach within the time frame. (for pagination)
   * @param coachId
   * @param startDate
   * @param endDate
   * @param offset
   * @param limit
   * @returns SimpleShiftWithJobAndCountListSchemaOut Successful Response
   * @throws ApiError
   */
  public getSpGetReservedShiftsByCoachVLatest(
    coachId: number,
    startDate: string = '2025-02-11',
    endDate: string = '2025-04-12',
    offset?: number | null,
    limit?: number | null
  ): CancelablePromise<SimpleShiftWithJobAndCountListSchemaOut> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/sp/coaches/coach/{coach_id}/reserved_shifts',
      path: {
        coach_id: coachId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        offset: offset,
        limit: limit,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Location Of Search Query In Map View
   * @param query
   * @returns LatLongWithName Successful Response
   * @throws ApiError
   */
  public postSpGetLocationOfSearchQueryInMapViewVLatest(
    query: string
  ): CancelablePromise<LatLongWithName> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/sp/coaches/map_view/location_query',
      query: {
        query: query,
      },
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coaches In Map View
   * @param requestBody
   * @returns CoachWithLocationAndShiftsAvailabilityType Successful Response
   * @throws ApiError
   */
  public postSpGetCoachesInMapViewVLatest(
    requestBody: CoachMapViewFilters
  ): CancelablePromise<Array<CoachWithLocationAndShiftsAvailabilityType>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/sp/coaches/map_view',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        300: `Popup notification`,
        404: `Not found`,
        422: `Validation Error`,
      },
    });
  }
}
